var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SectionBlogLandowners"},[_c('Row',_vm._l((_vm.blogs),function(blog){return _c('Column',{key:blog.id,attrs:{"md":4,"xl":3}},[_c('CardBlogLandowners',{attrs:{"blog":blog}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }